import Vue from 'vue'
import App from './App.vue'
import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuelidate from 'vuelidate'
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'
//import './assets/main.css'

import vuetify from './plugins/vuetify';
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
Vue.config.productionTip = false


// set default config
Vue.$cookies.config('1d')

// set global cookie
Vue.$cookies.set('theme','default');
//Vue.use(BootstrapVue)
//Vue.use(IconsPlugin)
//Vue.component('b-navbar', BNavbar)

import CryptoJS from 'crypto-js/crypto-js'

Vue.use(CryptoJS)

Vue.use(Vuelidate)
new Vue({
  router,
  axios,
  VueAxios,
  vuetify,
  render: h => h(App)
}).$mount('#app')
